import React, { Component } from 'react';
import Outbox from './Outbox.js';

export default class OutboxTelaahanStaf extends Component {
  render() {
    return (
      <Outbox type='TNDE_TELAAHAN_STAF'/>
    );
  }
}
